// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InputPhone .vti__input{font-family:var(--fonts-code);border-radius:var(--input-radius);background:transparent}.InputPhone .vti__dropdown:focus{background-color:var(--colors-gray-100);box-shadow:inset 0 0 0 2px var(--input-focus-border-color)}.InputPhone .vti__dropdown-list.below{margin-top:2px}.InputPhone .vti__dropdown-list.above{margin-bottom:2px}.InputPhone .vti__dropdown-item>span{font-family:var(--fonts-code)}\n", ""]);
// Exports
module.exports = exports;
